// extracted by mini-css-extract-plugin
export default {"helpLink":"AppFooter_helpLink__sTDTI","externalLink":"AppFooter_externalLink__67bqV","splitter":"AppFooter_splitter__deA-M"};